module.exports = __webpack_public_path__ + "static/Advantage04@3x.4a62ea08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage04@3x.png
// module id = 694
// module chunks = 216210090109534